import { PickingTaskListPage } from '@/features/picking-task/pages/PickingTaskListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/picking-task/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["picking_task.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PickingTaskListPage,
})